import { render } from "./HeroiconsSolidDotsHorizontal.vue?vue&type=template&id=d1110e52"
const script = {}

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidDotsHorizontal.vue"]])

export default __exports__